import Widget from "./base.js";
import { render, Component } from "preact";
import Keypress from "keypress.js";
import SVGInjector from "svg-injector";
// import arrow from 'inc/apportionment-svg/arrow'
// import caOutline from 'inc/apportionment-svg/ca-outline'
// import ca2 from 'inc/apportionment-svg/ca-2'
// import oh2 from 'inc/apportionment-svg/oh-2'
// import constitution from 'inc/apportionment-svg/constitution'
// import dots from 'inc/apportionment-svg/dots'
// import groupPeople from 'inc/apportionment-svg/group-people'
// import singlePerson from 'inc/apportionment-svg/single-person'
// import staggeredGroups from 'inc/apportionment-svg/staggered-groups'
// import houseRepsMap from 'inc/apportionment-svg/house-reps-map'
// import houses from 'inc/apportionment-svg/houses'
// import houseSeats from 'inc/apportionment-svg/house-seats'
// import houseSeats2 from 'inc/apportionment-svg/house-seats-2'
// import tpmLogo from 'inc/apportionment-svg/tpm'

/*
  This component includes some non-react-style state management.
  This was simpler, and quicker, because this requires a lot of animation
  which is unduly complex in react w/o adding new dependencies 
*/
class SlideShow extends Component {
	constructor(props) {
		super(props);
		this.active = 0;
		this.keypressListener = new Keypress.Listener();
		const self = this;
		this.keypressListener.register_combo({
			keys: "left",
			on_keyup: (evt) => {
				self.slide(true);
			},
		});

		this.keypressListener.register_combo({
			keys: "right",
			on_keyup: (evt) => {
				self.slide();
			},
		});
	}

	componentDidMount() {
		//we need the svgs inline
		//github.com/iconic/SVGInjector
		//SVGInjector(elements, options, callback);
		const self = this;
		let touchstartX = 0;
		let touchendX = 0;

		const gestureZone = document.getElementById("tpmSlidesTrack");

		gestureZone.addEventListener(
			"touchstart",
			function (event) {
				touchstartX = event.changedTouches[0].screenX;
			},
			false
		);

		gestureZone.addEventListener(
			"touchend",
			function (event) {
				touchendX = event.changedTouches[0].screenX;
				handleGesture();
			},
			false
		);

		function handleGesture() {
			const diff = touchstartX - touchendX;
			//100px deadzone to prevent unwanted triggers
			if (Math.abs(diff) < 100) return;
			//pos is swipe right, neg is left
			if (diff > 0) {
				self.slide();
			}

			if (diff < 0) {
				self.slide(true);
			}
		}
		SVGInjector(document.querySelectorAll(".inject-me"), {}, () => {
			console.log("svginjector called");
			//finish setup after injection
			//taken from https://gist.github.com/SleepWalker/da5636b1abcbaff48c4d#gistcomment-3260989
		});
	}

	slide(back = false) {
		const idx = back ? this.active - 1 : this.active + 1;
		if (idx < 0 || idx > this.props.content.length - 1) return;
		document
			.querySelector("#tpmSlides .Slides__Track")
			.setAttribute("style", `transform:translateX(calc(-${idx} * 100%))`);
		this.active = idx;
		//750ms to match the transition timing in slides scss
		setTimeout(() => {
			document.querySelectorAll(".Slides__SlideInner").forEach((el) => {
				// el.classList.remove('animate')
				el.children.forEach((child) => {
					child.classList.remove("animate");
				});
			});
			// document.querySelector(`.slide-${this.active}`).classList.add('animate')
			document
				.querySelector(`.slide-${this.active}`)
				.children.forEach((child) => {
					// debugger
					child.classList.add("animate");
				});
		}, 750);
	}

	renderSlide(content, idx) {
		const isFirst = idx === 0;
		const isLast = idx === this.props.content.length - 1;
		const controls = (
			<div class={`${this.props.name}__Controls ${isFirst ? "--first" : ""}`}>
				{isFirst || isLast ? null : (
					<div
						class={`${this.props.name}__Control --prev ${
							isLast ? "--always-visible --last" : ""
						}`}
						onClick={() => {
							this.slide(true);
						}}
					>
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/arrow.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
				)}
				{isLast ? null : (
					<div
						class={`${this.props.name}__Control --next ${
							isFirst ? "--always-visible --first" : ""
						}`}
						onClick={() => {
							this.slide();
						}}
					>
						{isFirst ? "start " : ""}
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/arrow.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
				)}
			</div>
		);
		return (
			<div class={`Slides__Slide`}>
				<div class={`Slides__SlideInner ${this.props.name} slide-${idx}`}>
					{content}
					{controls}
				</div>
			</div>
		);
	}

	render() {
		let slides = [];
		this.props.content.forEach((content, idx) => {
			slides.push(this.renderSlide(content, idx));
		});
		return (
			<div id="tpmSlides" class="Slides">
				<div id="tpmSlidesTrack" class="Slides__Track">
					{slides}
				</div>
			</div>
		);
	}
}

/*
  If we need another slideshow in the future, create another widget like this 
  that renders a Slideshow component
*/
export class ApportionmentExplainerWidget extends Widget {
	get content() {
		return [
			<div class="ApportionmentSlide__Bookend --intro">
				<div class="text">
					<div class="logo">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/tpm.svg`}
							alt=""
							class="inject-me"
						/>{" "}
						Presents
					</div>
					<div class="apportionment">APPORTIONMENT</div>
					<div class="explained">explained</div>
				</div>
			</div>,
			<div class="ApportionmentSlide__Constitution">
				<div class="constitution">
					<img
						src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/constitution.svg`}
						alt=""
						class="inject-me"
					/>
				</div>
				<div class="text">
					The Constitution mandates a census every 10 years to count how many
					people live in each state.
				</div>
			</div>,
			<div class="ApportionmentSlide__HouseMap">
				<div class="text">
					The census is used to determine how many members of the House of
					Representatives each state&nbsp;gets.
				</div>
				<div class="map">
					<img
						src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/house-reps-map.svg`}
						alt=""
						class="inject-me"
					/>
				</div>
			</div>,
			<div class="ApportionmentSlide__Definition">
				<div class="images first">
					<div class="group">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/group-people.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
					<div class="dots">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/dots.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
					<div class="person">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/single-person.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
				</div>
				<div class="images second">
					<div class="group group-1">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/group-people.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
					<div class="group group-2">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/group-people.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
					<div class="dots">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/dots.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
					<div class="person person-1">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/single-person.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
					<div class="person person-2">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/single-person.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
				</div>
				<div class="ApportionmentSlide__P text">
					<div class="apportionment">APPORTIONMENT</div> is the process of
					assigning the 435 members of the House of Representatives among the
					states.
				</div>
			</div>,
			<div class="ApportionmentSlide__Fourteenth">
				<div class="text">
					Apportionment is based on the total population of each state. This is
					guaranteed by the <span class="red">14th Amendment</span>{" "}
					<span class="green">
						which requires “counting the whole number of persons in each state.”
					</span>
				</div>
			</div>,
			<div class="ApportionmentSlide__California">
				<div class="images">
					<div class="ca-outline">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/ca-outline.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
					<div class="staggered-groups">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/staggered-groups.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
				</div>
				<div class="text">
					Before now, one’s immigration status has never mattered when it comes
					to the count used for apportionment.
				</div>
			</div>,
			<div class="ApportionmentSlide__Trump">
				<div class="trump"></div>
				<div class="text">
					But now President Trump wants to exclude undocumented immigrants from
					the apportionment count.
				</div>
			</div>,
			<div class="ApportionmentSlide__Houses">
				<div class="houses">
					<img
						src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/houses.svg`}
						alt=""
						class="inject-me"
					/>
				</div>
				<div class="text">
					By not including undocumented immigrants in the apportionment count,
					President Trump would decrease the amount of political representation
					for immigrant communities and increase political representation for
					whiter, rural populations.
				</div>
			</div>,
			<div class="ApportionmentSlide__HouseSeats1">
				<div class="seats">
					<img
						src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/house-seats.svg`}
						alt=""
						class="inject-me"
					/>
				</div>
				<div class="text">
					Apportionment is a zero-sum game. As one state loses a House seat,
					another state gains a seat, and vice versa.
				</div>
			</div>,
			<div class="ApportionmentSlide__CaOh">
				<div class="images">
					<div class="ca">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/ca-2.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
					<div class="dots">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/dots.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
					<div class="oh">
						<img
							src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/oh-2.svg`}
							alt=""
							class="inject-me"
						/>
					</div>
				</div>
				<div class="text">
					If Trump’s policy was allowed to be implemented, a state like
					California, with a relatively large population of undocumented
					immigrants, would receive one fewer House seat than expected after the
					2020 census, while Ohio, with relatively few undocumented immigrants,
					would keep a seat it would have otherwise lost, Pew estimates.
				</div>
			</div>,
			<div class="ApportionmentSlide__HouseSeats2">
				<div class="seats">
					<img
						src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/apportionment-slideshow/house-seats-2.svg`}
						alt=""
						class="inject-me"
					/>
				</div>
				<div class="text">
					As many as 24 seats would be in flux under President Trump’s new
					policy, which is being challenged in court.
				</div>
			</div>,
			<div class="ApportionmentSlide__Why">
				<div class="text">
					President Trump’s new policy reflects an agenda that undocumented
					immigrants shouldn’t count as people, and is in line with a
					longstanding conservative plan to change how apportionment works to
					benefit Republicans’ white, rural base.
				</div>
			</div>,
			<div class="ApportionmentSlide__Why">
				<div class="text">
					Not including undocumented immigrants in apportionment locks in an
					approach that helps Republicans maintain an electoral advantage
					despite the country becoming more diverse. More diverse,
					immigrant-rich parts of the country get less political representation;
					whiter parts of the country get more.
				</div>
			</div>,
			<div class="ApportionmentSlide__Bookend --outro">
				<div class="text">
					<div class="you-completed">you completed</div>
					<div class="apportionment">APPORTIONMENT</div>
					<div class="explained">explained</div>
					<a class="link" href="https://2020census.gov/" target="_blank">
						<span>fill out the census</span>
					</a>
					<div class="image-credit">
						Images and illustrations from Getty Images
					</div>
				</div>
			</div>,
		];
	}

	renderContent() {
		return <SlideShow content={this.content} name="ApportionmentSlide" />;
	}
}
